/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_alert_confirm_delete_passkey = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete passkey "${i?.name}"?`)
};

const zh_hans1_alert_confirm_delete_passkey = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您确定要删除通行密钥 “${i?.name}” 吗？`)
};

const zh_hant1_alert_confirm_delete_passkey = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您確定要刪除通行金鑰「${i?.name}」嗎？`)
};

const fr_alert_confirm_delete_passkey = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voulez-vous vraiment supprimer la passkey « ${i?.name} » ?`)
};

const de_alert_confirm_delete_passkey = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchtest du den Passkey „${i?.name}“ wirklich löschen?`)
};

const ja_alert_confirm_delete_passkey = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`パスキー「${i?.name}」を削除してもよろしいですか？`)
};

const ko_alert_confirm_delete_passkey = /** @type {(inputs: { name: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`패스키 "${i?.name}"을(를) 삭제하시겠습니까?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ name: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const alert_confirm_delete_passkey = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.alert_confirm_delete_passkey(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("alert_confirm_delete_passkey", locale)
	if (locale === "en") return en_alert_confirm_delete_passkey(inputs)
	if (locale === "zh-Hans") return zh_hans1_alert_confirm_delete_passkey(inputs)
	if (locale === "zh-Hant") return zh_hant1_alert_confirm_delete_passkey(inputs)
	if (locale === "fr") return fr_alert_confirm_delete_passkey(inputs)
	if (locale === "de") return de_alert_confirm_delete_passkey(inputs)
	if (locale === "ja") return ja_alert_confirm_delete_passkey(inputs)
	return ko_alert_confirm_delete_passkey(inputs)
};